import { Row, Typography } from "antd";
import LinearGauge, { ColorCodedGaugeOptions, LinearGaugeType } from "./LinearGauge";
import { useEffect, useMemo, useState } from "react";
import "./shared.css";
import React from "react";
import { formatNumber } from "src/utils/formatting";

const { Text } = Typography; 

export interface PressureGauge {
    pressure: number | null | undefined;
    label: string;
}

const PressureGauge : React.FC<PressureGauge> = ({ pressure, label}) => {

    const pressureScaleData = useMemo(() => {
        return [0, 1.5, 3, 4.5, 6, 7.5, 9, 10.5, 12, 13.5, 15]
    }, []);
    
    const [headerColor, setHeaderColor] = useState<string>("green");

    const colorCodedGaugeOptions : ColorCodedGaugeOptions = {
        ranges: [
            {
                start: 0,
                end: 7.5,
                color:"green"
            },
            {
                start: 7.5,
                end: 9,
                color:"yellow"
            },        
            {
                start: 9,
                end: 15,
                color:"red"
            }
        ]
    }

    useEffect( () => {

        if(pressure != null){
            if(pressure >= 0 && pressure <= 7.5){
                setHeaderColor("green");
            }else if(pressure >= 7.5 && pressure <= 9 ){
                setHeaderColor("yellow");
            }else if(pressure >= 9 && pressure <= 15 ){
                setHeaderColor("red");
            }
        }
        
    }, [pressure]);
    return(
        <div style={{ width:'100%' }}>
            <div 
            className="custom-gauge-header" 
            style={{ backgroundColor: headerColor }}>
                <Text style={{ fontFamily:'monospace', color:'white', fontWeight: "bold" }}>{label}: {formatNumber(pressure, { decimalPlaces: 2 })}</Text>
            </div>
            <div className="custom-gauge-div">
                <LinearGauge 
                currentValue={pressure} 
                scaleData={pressureScaleData} 
                colorCodedGaugeExists={true}
                colorCodedGaugeOptions={colorCodedGaugeOptions}
                type={LinearGaugeType.Pressure}
                needleAnimationSpeed={0.05}
                />
            </div>
        </div>

    )
}

export default PressureGauge;